import { useQuery } from 'react-query';
import { usePublicApiClient } from '../usePublicApiClient';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi';
import { ContentfulCollection } from '@jbhi-fi/apis/src/contentful/types';

export type UseAttachSuggestionProps = {
  purchasedCategoryId?: number;
  contentfulThemeApiClient?: ContentfulThemeApiClient;
  isAttachSuggestionEnabled?: boolean;
};

export type UseAttachSuggestionResult = {
  isLoading: boolean;
  attachHeading?: string;
  suggestedCategories?: Array<ContentfulCollection>;
};

export const useAttachSuggestion = ({
  purchasedCategoryId,
  contentfulThemeApiClient: contentfulThemeApiClientProp,
  isAttachSuggestionEnabled = true,
}: UseAttachSuggestionProps): UseAttachSuggestionResult => {
  const { contentfulThemeApiClient: contentfulThemeApiClientContext } = usePublicApiClient();
  const contentfulThemeApiClient = contentfulThemeApiClientProp || contentfulThemeApiClientContext;
  if (!contentfulThemeApiClient) {
    throw new Error(
      'useAttachCategorySuggestions must be provided with a contentfulThemeApiClient via PublicApiClientProvider or props'
    );
  }

  const { isLoading, data: { data } = {} } = useQuery({
    enabled: Boolean(purchasedCategoryId && contentfulThemeApiClient && isAttachSuggestionEnabled),
    queryKey: ['useAttachCategorySuggestions', purchasedCategoryId],
    queryFn: () =>
      contentfulThemeApiClient?.getAttachCategorySuggestions({ purchasedCategoryId: purchasedCategoryId! }),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const suggestion = data?.attachSuggestionCollection?.items?.[0];

  return {
    isLoading: isLoading,
    attachHeading: suggestion?.attachHeading,
  };
};
